import { disconnectAll, refreshSockets } from "@/lib/socketManager";
import { appStore } from "@/store/jotaiStore";
import { socketsAtom } from "@/store/socketsAtom";
import type { TokenResponse } from "../types/auth";

export const setTokensInStorage = async (tokens: TokenResponse) => {
  localStorage.setItem("access_token", tokens.accessToken);
  localStorage.setItem("refresh_token", tokens.refreshToken);

  // Force sockets to reconnect with the new access token.
  const newMap = refreshSockets(tokens.accessToken);
  // Update the global jotai atom so React hooks start using the fresh sockets.
  appStore.set(socketsAtom, newMap);
};

export const clearTokensFromStorage = () => {
  localStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");

  // Disconnect sockets on logout.
  disconnectAll();
  appStore.set(socketsAtom, null);
};
